import { ErrorType } from '../../errors-handler/ErrorsHandler.types';
import { extractErrorEventInfo } from '../ErrorViews.utils';

export const isNewVersionAvailableError = ({ event }: ErrorType) => {
  const { message, src } = extractErrorEventInfo(event);
  return (
    message.includes('AsyncRequireError') ||
    src?.includes('/libheif-bundle-') ||
    src?.includes('/photosi-sdk-web-') ||
    src?.startsWith('/_expo/static/js/') ||
    src?.startsWith('/node_modules') ||
    src?.startsWith('/src')
  );
};
